import dayjs from "dayjs";

import { MeReadDtoLangEnum } from "@/config/apiClient";

const LOCALE_MAP: Record<MeReadDtoLangEnum, string> = {
  [MeReadDtoLangEnum.Fr]: "fr",
  [MeReadDtoLangEnum.En]: "en",
  [MeReadDtoLangEnum.De]: "de",
  [MeReadDtoLangEnum.It]: "it",
  [MeReadDtoLangEnum.Es]: "es",
  [MeReadDtoLangEnum.Gr]: "el",
  [MeReadDtoLangEnum.Pl]: "pl",
  [MeReadDtoLangEnum.Hr]: "hr",
  [MeReadDtoLangEnum.Sl]: "sl",
  [MeReadDtoLangEnum.Jp]: "ja",
};

export const getHumainDurationFromNow = (
  date: Date,
  locale: MeReadDtoLangEnum = MeReadDtoLangEnum.En
) => {
  const dayjsLocale = LOCALE_MAP[locale];
  const dayjsInstance = dayjs(date).locale(dayjsLocale);

  return dayjsInstance.fromNow();
};
